/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowLeftThick: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-left-thick" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1380.1875 680L746.7675 46.5374999999999L613.2325000000001 180.0725L1018.6825 585.5224999999999H18.9125V774.3924999999998H1018.6825L613.2325000000001 1179.8424999999997L746.7675 1313.3774999999998L1380.1875 679.9574999999998z" : "M1104.15 544L597.4140000000001 37.23L490.5860000000001 144.058L814.946 468.4179999999999H15.13V619.5139999999999H814.946L490.5860000000001 943.8739999999998L597.4140000000001 1050.7019999999998L1104.15 543.9659999999999z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowLeftThick.displayName = `Blueprint5.Icon.ArrowLeftThick`;
export default ArrowLeftThick;
